export default "__VITE_ASSET__C$Ii3vy8__"